import { T } from "../themes";

// Highlight numbers, measurements, and metrics in AI-generated text.
// Two mechanisms:
//   1. **marker** — explicit prompt instruction; strip asterisks, render content highlighted
//   2. Regex  — numbers with recognised units (comma-formatted, /day|/week suffix)
//              Standalone bare numbers are NOT highlighted (too noisy).
export function highlightAIText(text) {
  if (!text || typeof text !== "string") return [{ text: text || "", highlight: false }];

  // NUMBER: comma-formatted (24,383) or plain integer/decimal (2332, 0.6)
  const NUMBER = '(?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d+)?';
  // UNITS: all recognised nutrition / fitness units
  const UNITS  = '(?:calories?|kcal|kJ|kg|g|mg|ml|l|%|lbs?|oz|km|m|mins?|minutes?|hours?|hrs?|steps?|days?|weeks?|months?)';
  // SUFFIX: optional per-period qualifier (e.g. /day, /week)
  const SUFFIX = '(?:\\/(?:day|week|month|hr|hour))?';

  const pattern = new RegExp(
    // 1. **marker** — explicit highlight from prompt; capture inner text (no asterisks shown)
    '\\*\\*([^*]+)\\*\\*' +
    // 2. Number (comma-aware) + optional space + unit + optional /period suffix
    `|\\b${NUMBER}\\s*${UNITS}${SUFFIX}\\b` +
    // 3. Time pattern HH:MM (e.g. wake / bed times)
    '|\\b\\d{1,2}:\\d{2}\\b',
    'gi'
  );

  const parts = [];
  let lastIndex = 0;
  let match;
  const regex = new RegExp(pattern.source, pattern.flags);
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ text: text.slice(lastIndex, match.index), highlight: false });
    }
    // match[1] defined → **marker** fired; display content without the asterisks
    parts.push({ text: match[1] !== undefined ? match[1] : match[0], highlight: true });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push({ text: text.slice(lastIndex), highlight: false });
  }
  return parts.length > 0 ? parts : [{ text, highlight: false }];
}

export default function AIText({ text, persona, style }) {
  if (!text) return null;
  const accentColor = T.primary;
  const parts = highlightAIText(text);
  return (
    <span style={style}>
      {parts.map((part, i) =>
        part.highlight
          ? <span key={i} style={{ color: accentColor, fontWeight: 700 }}>{part.text}</span>
          : <span key={i}>{part.text}</span>
      )}
    </span>
  );
}
